var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHoverVerified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.39122 18.1738H12.6956V33.9999H5.39122C5.06835 33.9999 4.7587 33.8717 4.53039 33.6433C4.30209 33.415 4.17383 33.1054 4.17383 32.7825V19.3912C4.17383 19.0683 4.30209 18.7587 4.53039 18.5304C4.7587 18.3021 5.06835 18.1738 5.39122 18.1738Z",
    stroke: "#1859B4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6953 18.1739L18.7823 6C20.0738 6 21.3123 6.51304 22.2256 7.42626C23.1388 8.33948 23.6518 9.57808 23.6518 10.8696V14.5217H33.391C33.7363 14.5218 34.0777 14.5954 34.3925 14.7376C34.7073 14.8797 34.9882 15.0873 35.2166 15.3463C35.445 15.6054 35.6157 15.9101 35.7173 16.2402C35.8189 16.5703 35.8491 16.9182 35.806 17.2609L33.9799 31.8696C33.9058 32.4578 33.6195 32.9988 33.1749 33.3911C32.7303 33.7833 32.1578 33.9998 31.5649 34H12.6953",
    stroke: "#1859B4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverVerified);
export default __webpack_public_path__ + "static/media/hover-verified.90000d1057e0947d0dce571603e717bb.svg";
export { ForwardRef as ReactComponent };